import { ROUTE_SEARCH } from "@/constants/routes.constants";
import { AppContext } from "@/services/AppContext/appContext";
import React, { useContext } from "react";
import { useNavigate } from "react-router";

type SidebarFavoritesDisplaySectionProps = {
  // TODO: add props here
};

const SidebarFavoritesDisplaySection: React.FC<
  SidebarFavoritesDisplaySectionProps
> = (props) => {
  const nav = useNavigate();
  const { favoriteSearches } = useContext(AppContext);

  function isActiveFavorite(search: string): boolean {
    if (favoriteSearches.length === 0) {
      return false;
    }

    const isActive = search === location.search;

    return isActive;
  }

  return (
    <div className="flex flex-col gap-2 ps-1 overflow-y-auto">
      {[...favoriteSearches]
        .sort((a, b) => a.favourite_order - b.favourite_order)
        .map((search) => (
          <div
            className={`cursor-pointer w-full truncate text-xs hover:underline shrink-0 ${
              isActiveFavorite(search.search) ? "font-bold" : "font-extralight"
            }`}
            key={search.id}
            onClick={() => {
              nav(`${ROUTE_SEARCH}${search.search}`);
            }}
          >
            {search.name}
          </div>
        ))}
    </div>
  );
};

export default SidebarFavoritesDisplaySection;
